export default __webpack_public_path__ + "static/media/skippedmeal_5.536415fe.jpg";